import { GeneralSectionLabels } from '../../xdrIncidentDetails';

export interface AnalysisSection {
  // all the data needed for rendering
  status: string;
  assignee: string;
  priority: string;
}

export enum EdrIncidentDetailsPanelEvents {
  SHOW_EDR_GRAPH = 'showEdrGraph',
  SHOW_EDR_EVENTS = 'showEdrEvents',
  ALERT_OPENED = 'alertOpened',
  ALERT_CLOSED = 'alertClosed',
}

export interface GeneralSection {
  number: number;
  created: string;
  lastUpdated: string;
  company: Object;
  score: string;
  isCustomer: boolean;
  type: number;
  isGzDemo: boolean;
}

export interface AnalysisSectionLabels {
  sectionTitle: string;
  status: string;
  assignee: string;
  priority: string;
}

export interface TechniquesSectionLabels {
  sectionTitle: string;
}

export interface DetectionsSectionLabels {
  sectionTitle: string;
  incidentTrigger: string;
  noResults: string;
  showMoreBtn: string;
}

export interface AttackInfoSectionLabels {
  sectionTitle: string;
  actionTaken: string;
  alerts: string;
  entities: string;
  resources: string;
  correlatedIncidents: string;
  killChainPhases: string;
  showMoreBtn: string;
  operatingSystem: string;
  artifacts: string;
  onEntityText: string;
  actorsTitle: string;
}

export interface TranslationsLabelsForEdrDetails {
  incidentDetailsTitle: string;
  graphButtonText: string;
  eventsButtonText: string;
  analysisSectionLabels: AnalysisSectionLabels;
  detectionsSectionLabels: DetectionsSectionLabels;
  generalSectionLabels: GeneralSectionLabels;
  techniquesSectionLabels: TechniquesSectionLabels;
  attackInfoSectionLabels: AttackInfoSectionLabels;
}
